package top.wcpe.allincore.ui.runtime.theme

/**
 * ItemStack 控件主题令牌（ADR-0048 内部分组）。
 *
 * 由 [ControlTheme] 内部持有，`ControlTheme` 的 `itemStackXxx` accessor 委托至此——签名不变、消费者零改动。
 * 字段名去 `itemStack` 前缀（holder 已表明归属）。默认值与原 `ControlTheme.Builder` 一致（零回归）。
 */
data class ItemStackTokens(
    val backgroundColor: Int = DEFAULT_BACKGROUND,
    val backgroundInnerColor: Int = DEFAULT_BACKGROUND_INNER,
    val hoverColor: Int = DEFAULT_HOVER,
) {
    private companion object {
        private const val DEFAULT_BACKGROUND = 0xFF8B8B8B.toInt()
        private const val DEFAULT_BACKGROUND_INNER = 0xFF373737.toInt()
        private const val DEFAULT_HOVER = 0x80FFFFFF.toInt()
    }
}
